export const KPI_COLUMN = {
  accessor: 'kpi',
  header: 'KPI'
} as const; 